<script lang="ts">
  let { label = 'Est.', title = 'Model estimate — not a count' }: { label?: string; title?: string } = $props();
</script>

<span class="est-chip" {title}>
  <svg width="9" height="9" viewBox="0 0 10 10" aria-hidden="true"><path d="M5 0l1.4 3.6L10 5 6.4 6.4 5 10 3.6 6.4 0 5l3.6-1.4z" fill="currentColor" /></svg>{label}
</span>
